const CLIENT_TYPE_KEY = 'driver_learning_client_type'

/**
 * 判断当前设备是否倾向于手机端
 */
export function isMobileDevice() {
    const width = window.innerWidth || document.documentElement.clientWidth
    const ua = navigator.userAgent || ''

    const mobileUA = /Android|iPhone|iPod|Windows Phone|Mobile/i.test(ua)

    return mobileUA || width <= 768
}

/**
 * 获取自动识别的客户端类型
 */
export function getAutoClientType() {
    return isMobileDevice() ? 'mobile' : 'pc'
}

/**
 * 获取当前客户端类型
 *
 * 优先级：
 * 1. 用户手动选择
 * 2. 系统自动识别
 */
export function getClientType() {
    const saved = localStorage.getItem(CLIENT_TYPE_KEY)

    if (saved === 'pc' || saved === 'mobile') {
        return saved
    }

    return getAutoClientType()
}

/**
 * 保存用户手动选择的客户端类型
 */
export function setClientType(type) {
    if (type === 'pc' || type === 'mobile') {
        localStorage.setItem(CLIENT_TYPE_KEY, type)
    }
}

/**
 * 清除用户手动选择，恢复自动识别
 */
export function clearClientType() {
    localStorage.removeItem(CLIENT_TYPE_KEY)
}

/**
 * 根据角色和客户端类型获取首页路径
 */
export function getHomePathByRole(role, clientType) {
    const type = clientType || getClientType()

    if (type === 'mobile') {
        if (role === 'ADMIN') {
            return '/m/admin/student'
        }

        if (role === 'STUDENT') {
            return '/m/student/home'
        }

        return '/m/login'
    }

    if (role === 'ADMIN') {
        return '/admin/home'
    }

    if (role === 'STUDENT') {
        return '/student/home'
    }

    return '/login'
}

/**
 * 根据当前路由判断应该跳转到哪个登录页
 */
export function getLoginPathByRoutePath(path) {
    if (path && path.startsWith('/m')) {
        return '/m/login'
    }

    return getClientType() === 'mobile' ? '/m/login' : '/login'
}

/**
 * 根据当前路由判断客户端类型
 */
export function getClientTypeByRoutePath(path) {
    if (path && path.startsWith('/m')) {
        return 'mobile'
    }

    if (path && (path.startsWith('/admin') || path.startsWith('/student'))) {
        return 'pc'
    }

    return getClientType()
}